import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';
import { OrganizationType } from 'src/app/shared/enums/organization-type.enum';

export class ModuleModel {
  id: number;
  name: string;
  identifier: string;
}

export class ModuleMatrix {
  organizationId: number;
  moduleIds: number[];
  organizationName: string;
  organizationType: OrganizationType;
}

export class ModuleMatrixRow {
  organizationId: number;
  organizationName: string;
  organizationType: OrganizationType;
  modules: ModuleItem[];
}

export class ModuleItem {
  module: ModuleModel;
  organizationHasModule: boolean;
  updating: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
}

export class ModuleMatrixSearchEvent {
  organizationId: number | null;
  query?: string | null;
  paging: PageEvent;
  sorting: Sort | null;
}
